import { signIn, useSession } from 'next-auth/react';
import { User } from 'modules/auth/types/auth.types';

interface UseAuthSession {
  user: User | null;
  status: string;
  accessToken: string | null;
  accessTokenExpiry: number;
  error: string;
}

export const useAuthSession = (): UseAuthSession => {
  const { data, status } = useSession({
    required: true,
    onUnauthenticated() {
      sessionStorage.clear();
      // @ts-ignore

      return signIn('auth0');
    },
  });

  return {
    user: data?.user || null,
    status,
    accessToken: (data?.accessToken as string) || null,
    accessTokenExpiry: data?.accessTokenExpiry as number,
    error: data?.error as string,
  };
};
